import { render, staticRenderFns } from "./LostForm.vue?vue&type=template&id=beca536e&scoped=true&"
import script from "./LostForm.vue?vue&type=script&lang=js&"
export * from "./LostForm.vue?vue&type=script&lang=js&"
import style0 from "./LostForm.vue?vue&type=style&index=0&id=beca536e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beca536e",
  null
  
)

export default component.exports